import { DATES_RESTRICTIONS_CATEGORY } from '../../checklistCategories';
import type { ApprovalQueueItem } from '../../types';

import type { DatesRestrictionsChecklistRow } from './types';

export function buildDatesRestrictionsQueueItem(row: DatesRestrictionsChecklistRow): ApprovalQueueItem {
  return {
    categoryId: DATES_RESTRICTIONS_CATEGORY.id,
    categoryLabel: DATES_RESTRICTIONS_CATEGORY.label,
    description: `${row.title} requires approval.`,
    details: [{ label: 'Rule', value: row.rule }, { label: 'Source value', value: row.sourceValue }, ...row.details],
    id: row.id,
    title: row.title,
  };
}

export function getDatesRestrictionsSearchText(row: DatesRestrictionsChecklistRow) {
  return [row.title, row.rule, row.sourceValue, row.statusLabel].filter(Boolean).join(' ');
}
